<template>
  <div class="showGantt">
    <!-- <input value="撤回" type="button" onclick="gantt.undo();" />
    <input value="重置" type="button" onclick="gantt.redo();" />
    -->
    <div class="header-wrapper">
      <div class="header-left">
        <!-- 
        <el-input
          placeholder="请输入内容"
          prefix-icon="el-icon-search"
          v-model="searchValue"
          @change="searchChange"
        ></el-input>
        -->
      </div>
      <div class="header-right">
        <!-- 
        <h4>{{(Array.isArray(this.timeDate) && !this.timeDate[0])?'默认展示全部时间':`开始时间：${this.timeDate[0]} ~ 结束时间：${this.timeDate[1]}`}}</h4>
        -->
        <h4>{{showTitle}}</h4>
        <el-select
          v-model="timelineValue"
          clearable
          placeholder="请选择"
          class="c-m-r-10"
          @change="timelineChange"
        >
          <el-option
            v-for="item in timeline"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-date-picker
          style="width:300px"
          v-model="timeDate"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          @change="dateChange"
        ></el-date-picker>
      </div>
    </div>
    <gantt ref="gantt" style="height: 100%;" :tasks.sync="tasks" :myData.sync="myData"></gantt>
    <!--<input value="导出PDF" type="button" onclick="gantt.exportToPDF()" /> 
    <input value="导出Excel" type="button" onclick="gantt.exportToExcel()" />
    -->
  </div>
</template>

<script>
import Gantt from "./Gantt";
export default {
  name: "showGantt",
  components: { Gantt },
  data() {
    return {
      searchValue: "",
      timeDate: [],
      timelineValue: "D",
      showTitle: "默认展示全部时间",
      timeline: [
        { label: "显示年", value: "Y" },
        { label: "显示月", value: "M" },
        { label: "显示日", value: "D" },
        { label: "显示时", value: "H" }
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近两天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      tasks: {
        data: [
          // {
          //   id: 1,
          //   text: "Project #1",
          //   type: "project", //项目任务与常规任务之间的区别在于，项目任务的持续时间取决于其子任务，并且会分别更改。
          //   open: true
          // }
          // {
          //   id: 2,
          //   text: "Task #1",
          //   start_date: "12-04-2013",
          //   duration: 3,
          //   parent: 1,
          //   render: "split"
          // },
          // {
          //   id: 21,
          //   text: "value #1.1",
          //   start_date: "12-04-2013",
          //   duration: 3,
          //   parent: 2
          // },
          // {
          //   id: 22,
          //   text: "value #1.2",
          //   start_date: "12-04-2013",
          //   duration: 3,
          //   parent: 2
          // },
          // {
          //   id: 3,
          //   text: "Alpha release",
          //   duration: 1,
          //   parent: 1,
          //   start_date: "14-04-2013"
          // }
          // {
          //   text: "任务名", //任务名
          //   start_date: "19-04-2020", //开始时间
          //   id: 1, //任务id
          //   duration: 3, //任务时长，从start_date开始计算
          //   progress: 0.5, //任务完成情况，进度
          //   // parent: 2, //父任务ID
          //   user: "李四", //成员
          //   planned_end: "19-04-2020", //计划开始时间
          //   planned_start: "10-04-2020", //计划结束时间
          //   show: false,
          //   open: true, //默认是否打开
          //   type: "task" // gantt.config.types.milestone为里程碑类型
          //   // project为项目任务类型，也就是摘要任务，
          //   // task为普通任务类型
          // },
          // {
          //   id: 2,
          //   text: "Task #1",
          //   start_date: "15-04-2020",
          //   duration: 3,
          //   progress: 0.6,
          //   render: "split",
          //   type: "project"
          // },
          // {
          //   id: 11,
          //   text: "Task #1.1",
          //   start_date: "19-04-2020",
          //   duration: 3,
          //   progress: 0.6,
          //   parent: 2
          // },
          // {
          //   id: 12,
          //   text: "Task #1.2",
          //   start_date: "28-04-2020",
          //   duration: 3,
          //   progress: 0.6,
          //   parent: 2
          // },
          // {
          //   id: 3,
          //   text: "Task #2",
          //   start_date: "18-04-2020",
          //   duration: 3,
          //   progress: 0.4
          // },
          // {
          //   id: 1,
          //   text: "Task #2",
          //   start_date: "03-04-2018 00:00",
          //   type: "project",
          //   render: "split",
          //   parent: 0
          // },
          // {
          //   id: 2,
          //   text: "Task #2.1",
          //   start_date: "03-04-2018 00:00",
          //   duration: 1,
          //   parent: 1
          // },
          // {
          //   id: 3,
          //   text: "Task #2.2",
          //   start_date: "05-04-2018 00:00",
          //   duration: 2,
          //   parent: 1
          // },
          // {
          //   id: 4,
          //   text: "Task #2.3",
          //   start_date: "08-04-2018 00:00",
          //   duration: 1,
          //   parent: 1
          // }
        ]
        // links: [
        //   // links为任务之间连接的线
        //   { id: 1, source: 1, target: 2, type: "0" }, //source根源 target目标 也就是从id为1的指向id为2的
        //   { id: 2, source: 2, target: 3, type: "0" }
        //   //type:'0'是从1任务完成到2任务开始，type:'1'是1任务开始到2任务开始，
        //   //type:'2'是从1任务完成到2任务完成，type:'3'是从1任务开始到2任务完成
        // ]
      },
      myData: {
        // gantt.config.start_date = new Date(2018, 08, 10);
        // gantt.config.end_date = new Date(2018, 08, 20);
        config: {
          // start_date: new Date("2020-3-20"),
          // end_date: new Date()
          // start_date: new Date(2018, 08, 10)
          // columns: {
          //   name: "text",
          //   label:
          //     "<div class='searchEl'>Task name <input id='search' type='text'" +
          //     "placeholder='Search tasks...'></div>",
          //   width: 250,
          //   tree: true
          // }
        }
        // scale_unit: "month", //按年显示"year", "month";	//按月显示
        // step: 1, //设置时间刻度的步长（X轴）
        // date_scale: "%M", //日期尺度按年     = "%F, %Y";		//设置时间刻度的格式（X轴） 多个尺度
        // // gantt.config.scale_height = 50; //设置时间刻度的高度和网格的标题
        // subscales: [{ unit: "month", step: 10, date: "%j, %D" }], //指定第二个时间刻度
        // // 'gantt.templates'对象  模板可用于更改日期和标签的显示。
        // // 要定义模板，只需按照本文档中的说明进行编写即可。请记住，模板的定义应该在dhtmlxGantt初始化的代码行之前。
        // task_text: (start, end, task) => {
        //   return (
        //     // "<b>Text:</b> " + task.text + ",<b> Holders:</b> " + task.users
        //     `<div class="green"
        //     }"  ><b>${task.text}:</b> ${task.users}</div>`
        //   );
        // }
      }
    };
  },
  mounted() {
    // this.getData();
    this.$set(this.myData.config, "scale_unit", "day");
    this.$set(this.myData.config, "date_scale", "%M");
    this.$set(this.myData.config, "duration_unit", "hour");
    this.$set(this.myData.config, "subscales", [
      { unit: "day", step: 1, format: "周%D，%j号" }
    ]);
  },
  methods: {
    // getData() {
    //   this.osg.ajax(
    //     "basic/serviceAppointment/queryByServiceCrew.do",
    //     {},
    //     res => {
    //       let arr = res.data;
    //       arr.forEach(item => {
    //         let obj = {};
    //         obj.id = item._id;
    //         obj.text = item.orgName;
    //         obj.type = "project";
    //         obj.open = true;
    //         this.tasks.data.push(obj);
    //         if (item.userList.length) {
    //           item.userList.forEach(el => {
    //             let data1 = el.createTime.substr(
    //               el.createTime.indexOf(" ") + 1
    //             );
    //             data1 = "00:00";
    //             data1
    //               .split(":")
    //               .reverse()
    //               .join(":");
    //             let data2 = el.createTime.substr(0, el.createTime.indexOf(" "));
    //             data2 = data2
    //               .split("-")
    //               .reverse()
    //               .join("-");

    //             let obj = {};
    //             obj.id = el._id;
    //             obj.text = el.name;
    //             obj.start_date = data1 + " " + data2;
    //             obj.parent = item._id;
    //             this.tasks.data.push(obj);
    //           });
    //         }
    //         this.$forceUpdate();
    //         // this.$foucn
    //         console.log(this.tasks);
    //       });
    //     }
    //   );
    // },
    //时间区间切换
    dateChange() {
      if (this.timeDate && this.timeDate.length) {
        this.$set(this.myData.config, "start_date", this.timeDate[0]);
        this.$set(this.myData.config, "end_date", this.timeDate[1]);
        console.log(this.myData.config);
        this.$forceUpdate();
      } else {
        this.$set(this.myData.config, "start_date", "");
        this.$set(this.myData.config, "end_date", "");
        this.$forceUpdate();
      }
      if (Array.isArray(this.timeDate)) {
        let date1 = this.timeDate[0].toLocaleString("chinese", {
          hour12: false
        });
        let date2 = this.timeDate[1].toLocaleString("chinese", {
          hour12: false
        });
        this.showTitle = !this.timeDate[0]
          ? "默认展示全部时间"
          : `开始时间：${date1.substr(
              0,
              date1.indexOf(" ")
            )} ~ 结束时间：${date2.substr(0, date2.indexOf(" "))}`;
      } else {
        this.showTitle = "默认展示全部时间";
      }
    },
    //时间轴切换
    timelineChange() {
      // this.tasks = { data: [] };
      // console.log();
      // gantt.config.scale_unit = "day";
      //   gantt.config.date_scale = "周%D,%d号";
      //   gantt.config.duration_unit = "hour";

      if (this.timelineValue == "Y") {
        // this.myData.config.subscales = [
        //   { unit: "year", step: 1, date: "%Y年" }
        // ];
        this.$set(this.myData.config, "scale_unit", "year");
        this.$set(this.myData.config, "date_scale", "%Y年");
        this.$set(this.myData.config, "duration_unit", "hour");
        this.$set(this.myData.config, "subscales", [
          //   { unit: "year", step: 1, date: "%Y年" }
        ]);
      } else if (this.timelineValue == "M") {
        // this.myData.config.subscales = [{ unit: "month", step: 1, date: "%M" }];
        this.$set(this.myData.config, "scale_unit", "month");
        this.$set(this.myData.config, "date_scale", "%Y年");
        this.$set(this.myData.config, "duration_unit", "hour");
        this.$set(this.myData.config, "subscales", [
          { unit: "month", step: 1, date: "%M" }
        ]);
      } else if (this.timelineValue == "D") {
        // this.myData.config.subscales = [{ unit: "hour", step: 1, date: "%H" }];
        this.$set(this.myData.config, "scale_unit", "day");
        this.$set(this.myData.config, "date_scale", "%M");
        this.$set(this.myData.config, "duration_unit", "hour");
        this.$set(this.myData.config, "subscales", [
          { unit: "day", step: 1, format: "周%D，%j号" }
        ]);
      } else if (this.timelineValue == "H") {
        // this.myData.config.subscales = [{ unit: "hour", step: 1, date: "%H" }];
        this.$set(this.myData.config, "date_scale", "%j号");
        this.$set(this.myData.config, "scale_unit", "hour");
        this.$set(this.myData.config, "duration_unit", "hour");
        this.$set(this.myData.config, "subscales", [
          { unit: "hour", step: 1, date: "%H时" }
        ]);
      }
      this.$forceUpdate();
      // console.log(this.myData.config);
    },
    searchChange() {
      // this.$set(this.tasks, "data", []);
      // this.$refs.gantt.getData();
      // this.$set(this.myData, "params", {
      //   "regex:orgName|string#and": this.searchValue
      // });
      // console.log(this.$refs.gantt);
      // this.$forceUpdate();
      // console.log(this.myData);
    }
  }
};
</script>

<style scoped lang="scss">
.showGantt {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
}
h4 {
  width: 80%;
  height: 100%;
  line-height: 31px;
  text-align: center;
}
.header-wrapper {
  display: flex;
  width: 100%;
  padding: 14px 0px;
  box-sizing: border-box;
  .header-left {
    width: 360px;
  }
  .header-right {
    display: flex;
    flex: 1;
    justify-content: flex-end;
  }
}
</style>
